<template>
  <table-component
    ref="totalMacrosTable"
    :data="items"
    :show-caption="false"
    class="datatable"
    sort-by=""
    sort-order=""
    :show-filter="false">

    <table-column
      :sortable="false"
      show="name"
      :label="''"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

    <table-column
      :sortable="false"
      show="carbs"
      :label="$t('health.summary.carbs')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

    <table-column
      :sortable="false"
      show="proteins"
      :label="$t('health.summary.protein')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

    <table-column
      :sortable="false"
      show="fats"
      :label="$t('health.summary.fat')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

    <table-column
      :sortable="false"
      show="calories"
      :label="$t('health.summary.calories')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

    <table-column
      v-if="showFibre"
      show="fibre"
      :label="$t('health.summary.fibre')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

  </table-component>
</template>
<script>
import TableColumn from '@/components/shared/table/components/TableColumn';
import TableComponent from '@/components/shared/table/components/TableComponent';
export default {
  name: 'TotalMacrosTable',
  components: {
    TableComponent,
    TableColumn
  },
  props: {
    items: {
      default: []
    },
    showFibre: {
      default: false
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/TotalMacrosTable.vue